import * as Dialog from '@radix-ui/react-dialog'
import { useState } from 'react'
import { useTranslation } from '../localization/useTranslation'
import { usePortalContainer } from '../providers/portal'
import { IconWarn } from '../ui/icons'
import { OverlayReporter } from './OverlayReporter'

/**
 * Shown once when Core reports `allowedCountry === false` — we likely have no carrier from the
 * customer's country to our warehouse. It's a warning, not a block: the customer can dismiss it
 * and still complete the trade-in. Radix Dialog portalled into the shadow-root overlay node.
 */
export function CountryWarningDialog() {
  const { t } = useTranslation()
  const container = usePortalContainer()
  const [open, setOpen] = useState(true)

  return (
    // modal={false}: Radix's scroll-lock (react-remove-scroll) blocks the mouse wheel inside our
    // shadow root (it can't resolve the wheel target across the boundary). Disabling it restores
    // native wheel scrolling; scrim/Escape/outside-click still close it. (See TermsDialog.)
    <Dialog.Root open={open} onOpenChange={setOpen} modal={false}>
      <Dialog.Portal container={container ?? undefined}>
        {/* Plain scrim, not Dialog.Overlay: Radix renders Overlay as null when modal={false}. As a
            direct Portal child it's still open-state gated, and clicking it closes the dialog. */}
        <div className="modal-scrim" aria-hidden />
        <Dialog.Content className="modal" aria-describedby={undefined}>
          <OverlayReporter />
          <div className="modal-head">
            <Dialog.Title asChild>
              <h2>{t('country.title')}</h2>
            </Dialog.Title>
          </div>
          <div className="modal-body">
            <div className="callout">
              <IconWarn />
              <span>{t('country.body')}</span>
            </div>
          </div>
          <div className="modal-foot">
            <Dialog.Close asChild>
              <button type="button" className="btn btn-primary">
                {t('country.dismiss')}
              </button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
